import { INITIAL_PROFILE_REQUEST, FINAL_PROFILE_REQUEST, FETCH_PROFILE_SUCCESS } from "../types/profile.types";

const initialState = {
	property_name: "",
	supervisor_name: "",
	dosage_managers: [],
	machinery_managers: [],
	machinery: [],
	quarters: [],
	users: [],
	isFetching: false,
	error: null,
};

function profile(state = initialState, action) {
	switch (action.type) {
		case INITIAL_PROFILE_REQUEST:
			return {
				...state,
				isFetching: true,
				error: null,
			};
		case FINAL_PROFILE_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case FETCH_PROFILE_SUCCESS:
			return {
				...state,
				isFetching: false,
				property_name: action.payload.property_name,
				supervisor_name: action.payload.supervisor_name,
				dosage_managers: action.payload.dosage_managers,
				machinery_managers: action.payload.machinery_managers,
				machinery: action.payload.machinery,
				quarters: action.payload.quarters,
				users: action.payload.users,
			};
		default:
			return state;
	}
}

export default profile;
